import { useState, useEffect, useContext } from "react";
import { useSearchParams, useNavigate } from "react-router-dom"; // Pour extraire le token de l'URL
import ResetPasswordForm from "../../components/ResetPasswordForm/ResetPasswordForm";
import { LanguageContext } from '../../context/LanguageContext';

import styles from "./ResetPasswordPage.module.scss";

// Import des traductions 
import translations from '../../utils/translations/ResetPasswordPageTranslations';

import { resetPassword } from "../../utils/api/resetrequestAPI"; // Fonction API pour soumettre le mot de passe

import { DEBUG as debug } from '../../utils/constants';

const ResetPassword = () => {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token"); // ✅ Extraction du token depuis l'URL

  // Utilisation du contexte de langue global
  const { language } = useContext(LanguageContext);

  // Accès simplifié aux traductions
  const t = translations[language] || translations.fr;
  
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  // useEffect(() => {
  //   if (token) {
  //     if(debug) console.log(token);
  //   }
  // }, []);

  useEffect(() => {
    if (!token) {
      setError(t.invalidOrExpired);
    }
  }, [token]);

  const handleSubmit = async (password) => {
    // e.preventDefault();
    if (!token) {
      setError(t.invalidOrExpired);
      return;
    }

    setLoading(true);
    setMessage(null);
    setError(null);

    // try {
    //   const response = await resetPassword(password, token);
    // //   toast.success(response.message); // ✅ Succès
    // } catch (error) {
    // //   toast.error("Erreur lors de la réinitialisation du mot de passe.");
    // } finally {
    //   setLoading(false);
    // }
    try {
      const response = await resetPassword(password, token);

      if (response.status === "success") {
        setMessage(t.success);
      } else {
        setError(t.errorGeneric);
      }

    } catch (err) {
      setError(t.errorReset);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t.title}</h2>
      <ResetPasswordForm onSubmit={handleSubmit} loading={loading} />

      {message && <p className={styles.success}>{message}</p>}
      {error && <p className={styles.error}>{error}</p>}

      {message && (
        <p>
          <button
            type="button"
            onClick={() => navigate("/login")}
            className={styles.linkButton}
          >
            {t.loginCta}
          </button>
        </p>
      )}
    </div>
  );
};

export default ResetPassword;
